export default {"src":"https://gfiber.com/support/_next/static/media/GF-0074-CHAT WITH US.8e2070e1.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};